// src/app/App.js
import * as React from 'react';
import { Admin, Resource, CustomRoutes } from 'react-admin';
import { Route } from 'react-router-dom';
import dataProvider from '../data/dataProvider';
import authProvider from '../auth/authProvider';
import LoginPage from '../pages/LoginPage';
import Dashboard from '../pages/Dashboard';
import SitemapToolsPage from '../pages/SitemapToolsPage';
import ObservabilityPage from '../pages/ObservabilityPage';
import RdfGraphPage from '../pages/RdfGraphPage';
import AppLayout from '../layout/AppLayout';

import RdfList from '../resources/rdf/RdfList';
import RdfShow from '../resources/rdf/RdfShow';

// ✅ nouvelles ressources
import SubjectList from '../resources/subjects/SubjectList';
import SubjectShow from '../resources/subjects/SubjectShow';
import OobjectList from '../resources/oobjects/OobjectList';
import OobjectShow from '../resources/oobjects/OobjectShow';
import SubjectVariantList from '../resources/subjectVariants/SubjectVariantList';
import OobjectVariantList from '../resources/oobjectVariants/OobjectVariantList';
import PredicateList from '../resources/predicates/PredicateList';
import CommentReportList from '../resources/commentReports/CommentReportList';
import CommentReportShow from '../resources/commentReports/CommentReportShow';
import EntityReportList from '../resources/entityReports/EntityReportList';
import EntityReportShow from '../resources/entityReports/EntityReportShow';
import ContactMessageList from '../resources/contactMessages/ContactMessageList';
import ContactMessageShow from '../resources/contactMessages/ContactMessageShow';

export default function App() {
    return (
        <Admin
            dataProvider={dataProvider}
            authProvider={authProvider}
            loginPage={LoginPage}
            dashboard={Dashboard}
            layout={AppLayout}
            requireAuth
        >
            <CustomRoutes noLayout>
                <Route path="/login" element={<LoginPage />} />
            </CustomRoutes>
            <CustomRoutes>
                <Route path="/sitemap-tools" element={<SitemapToolsPage />} />
                <Route path="/observability" element={<ObservabilityPage />} />
                <Route path="/rdf-graph" element={<RdfGraphPage />} />
            </CustomRoutes>

            {/* RDF moderation */}
            <Resource
                name="rdf"
                options={{ label: 'RDF' }}
                list={RdfList}
                show={RdfShow}
            />

            {/* ✅ Subjects moderation */}
            <Resource
                name="subjects"
                options={{ label: 'Subjects' }}
                list={SubjectList}
                show={SubjectShow}
            />

            {/* ✅ Oobjects moderation */}
            <Resource
                name="oobjects"
                options={{ label: 'Oobjects' }}
                list={OobjectList}
                show={OobjectShow}
            />

            {/* Subject variants */}
            <Resource
                name="subject-variants"
                options={{ label: 'Subject Variants' }}
                list={SubjectVariantList}
            />

            <Resource
                name="oobject-variants"
                options={{ label: 'Oobject Variants' }}
                list={OobjectVariantList}
            />

            <Resource
                name="predicates"
                options={{ label: 'Predicates' }}
                list={PredicateList}
            />

            <Resource
                name="comment-reports"
                options={{ label: 'Comment Reports' }}
                list={CommentReportList}
                show={CommentReportShow}
            />

            <Resource
                name="entity-reports"
                options={{ label: 'Entity Reports' }}
                list={EntityReportList}
                show={EntityReportShow}
            />

            <Resource
                name="contact-messages"
                options={{ label: 'Contact Messages' }}
                list={ContactMessageList}
                show={ContactMessageShow}
            />

            {/* Tu pourras activer d’autres ressources ensuite :
            <Resource name="users" list={ListGuesser} />
            */}
        </Admin>
    );
}
